export const DATASET_INITIAL_VALUES = {
  devices: [],
  color: '',
  alias: '',
  timeslots: '',
  date: {},
};

export const FILTER_INITIAL_VALUES = {
  variable: '',
  granularity: '',
  showPhase: false,
  groups: [
    {
      disabled: false,
      datasets: [],
      dateStart: new Date(Date.now() - 24 * 60 * 60 * 1000),
      dateEnd: new Date(),
    },
    // {
    //   disabled: true,
    //   datasets: [],
    //   dateStart: new Date(Date.now() - 24 * 60 * 60 * 1000),
    //   dateEnd: new Date(),
    // },
    // {
    //   disabled: true,
    //   datasets: [],
    //   dateStart: new Date(Date.now() - 24 * 60 * 60 * 1000),
    //   dateEnd: new Date(),
    // },
  ],
};

export const initialGroup = {
  datasets: [],
  dateStart: new Date(Date.now() - 24 * 60 * 60 * 1000),
  dateEnd: new Date(),
}

export const CALENDAR_INITIAL_CONFIG = {
  views: ['month', 'year'],
  disabled: false,
  format: 'MM/yyyy',
};

export const getVariableUnit = (variable) => {
  switch (variable) {
    case 'TENSION_POR_FASE':
      return '#.##V';
    case 'CORRIENTE_POR_FASE':
      return "#.##'A";
    case 'POTENCIA_ADQUIRIDA_MAXIMA':
    case 'POTENCIA_ACTIVA_POR_FASE':
    case 'POTENCIA_ADQUIRIDA_TOTAL':
      return '#.##aW';
    case 'ENERGIA_REACTIVA_TOTAL':
    case 'ENERGIA_REACTIVA_POR_FASE':
      return '#.##aVAr';
    case 'ENERGIA_ACTIVA_POR_FASE':
    case 'ENERGIA_ACTIVA_TOTAL':
    case 'ENERGIA_ACTIVA_IMPORTADA_TOTAL':
    case 'ENERGIA_ACTIVA_EXPORTADA_TOTAL':
    case 'ENERGIA_ACTIVA_GENERADA_TOTAL':
    case 'ENERGIA_ACTIVA_CONSUMIDA_TOTAL':
    case 'ENERGIA_ACTIVA_AUTOCONSUMIDA_TOTAL':
    case 'ENERGIA_ACTIVA_AUTOCONSUMIDA_IMPORTADA_TOTAL':
    case 'ENERGIA_ACTIVA_TOTAL_ECOLOGICO':
      return '#.##aWh';
    case 'TEMPERATURA_TOTAL':
      return '#.## °C';
    case 'PRESION_TOTAL':
      return '# hPa';
    case 'HUMEDAD_TOTAL':
      return "#.## '%";
    case 'POTENCIA_ACTIVA_GENERADA_TOTAL':
    case 'POTENCIA_ACTIVA_CONSUMIDA_TOTAL':
      return '#.##aW';
    case 'COS_(FI)_POR_FASE':
    case 'COS_(FI)_TOTAL':
    case 'TAN_(FI)_POR_FASE':
    case 'TAN_(FI)_TOTAL':
      return '#.##'
    default:
      return '#.##aWh';
  }
}